<script>export var width = 30;
export var githubAuthor = '';
export var githubProject = '';
var info = [githubAuthor, githubProject];</script>

<div class="github">
	<a href={'https://github.com/' + info.join('/')}>
		<span
			class="iconify"
			data-icon="ant-design:github-outlined"
			data-inline="false"
			{width}
		/>
	</a>
</div>

<style>
	a {
		line-height: 1.5rem;
	}</style>
